import React from 'react';

const SECScheduleList = ({
  schedules,
  loading,
  onEdit,
  onDelete,
  onTriggerPoll,
  onBackfill,
  onViewFilings,
  onScheduleBurst,
  pollingScheduleId,
  backfillingScheduleId
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading schedules...</p>
      </div>
    );
  }

  if (schedules.length === 0) {
    return (
      <div className="alert alert-info">
        <i className="bi bi-info-circle me-2"></i>
        No schedules found. Create a new schedule to start monitoring SEC filings.
      </div>
    );
  }

  return (
    <div className="row">
      {schedules.map(schedule => (
        <div key={schedule.schedule_id} className="col-md-6 col-lg-4 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <h5 className="card-title mb-0">{schedule.name}</h5>
                <span className={`badge ${schedule.is_active ? 'bg-success' : 'bg-secondary'}`}>
                  {schedule.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>

              {schedule.description && (
                <p className="card-text text-muted small">{schedule.description}</p>
              )}

              <div className="mb-3">
                <div className="small mb-2">
                  <strong>Companies:</strong>
                  <div className="d-flex flex-wrap gap-1 mt-1">
                    {schedule.cik_numbers.map(cik => (
                      <span key={cik} className="badge bg-light text-dark">{cik}</span>
                    ))}
                  </div>
                </div>

                <div className="small mb-2">
                  <strong>Filing Types:</strong>
                  <div className="d-flex flex-wrap gap-1 mt-1">
                    {schedule.filing_types.map(type => (
                      <span key={type} className="badge bg-info text-dark">{type}</span>
                    ))}
                  </div>
                </div>

                <div className="small mb-2">
                  <strong>Frequency:</strong> Every {schedule.cadence_value} {schedule.cadence_unit}
                </div>

                {schedule.ms_teams_channel && (
                  <div className="small mb-2">
                    <strong>Teams Channel:</strong> 
                    <span className="badge bg-primary ms-1">
                      <i className="bi bi-microsoft-teams me-1"></i>
                      {schedule.ms_teams_channel}
                    </span>
                  </div>
                )}

                <div className="small text-muted">
                  <strong>Last Poll:</strong> {formatDate(schedule.last_poll_time)}
                </div>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => onEdit(schedule)}
                  title="Edit schedule"
                >
                  <i className="bi bi-pencil"></i>
                </button>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => onTriggerPoll(schedule.schedule_id)}
                  disabled={pollingScheduleId === schedule.schedule_id}
                  title="Trigger manual poll"
                >
                  {pollingScheduleId === schedule.schedule_id ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </>
                  ) : (
                    <i className="bi bi-arrow-repeat"></i>
                  )}
                </button>
                <button
                  className="btn btn-sm btn-outline-warning"
                  onClick={() => onScheduleBurst(schedule)}
                  title="Schedule burst polling session"
                >
                  <i className="bi bi-lightning-charge"></i>
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => onBackfill(schedule.schedule_id)}
                  disabled={backfillingScheduleId === schedule.schedule_id}
                  title="Backfill last 50 filings"
                >
                  {backfillingScheduleId === schedule.schedule_id ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </>
                  ) : (
                    <i className="bi bi-cloud-download"></i>
                  )}
                </button>
                <button
                  className="btn btn-sm btn-outline-info"
                  onClick={() => onViewFilings(schedule.schedule_id)}
                  title="View filings"
                >
                  <i className="bi bi-file-earmark-text"></i>
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onDelete(schedule.schedule_id)}
                  title="Delete schedule"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>

            <div className="card-footer text-muted small">
              <div>Created: {formatDate(schedule.created_at)}</div>
              <div>Updated: {formatDate(schedule.updated_at)}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SECScheduleList;
